module.exports = __webpack_public_path__ + "img/hz_32.cc63c972.jpg";